import CustomPriceField from "components/CustomPriceField";
import ApproveCommercialDocumentButton from "pages/commercialDocuments/components/ApproveCommercialDocumentButton";
import DeleteCommercialDocumentButton from "pages/commercialDocuments/components/DeleteCommercialDocumentButton";
import {
  ResourceContextProvider,
  List,
  Datagrid,
  TextField,
  Filter,
  SearchInput,
  FunctionField,
  PaginationLimit,
  Pagination,
  SelectInput,
} from "react-admin";
import EmptyComponent from "../../unapprovedCreditNotes/components/EmptyComponent";
import StatusField from "../../../components/StatusField";
import React from "react";
import { statusList } from "../const";
import NoteCommercialDocumentButton from "../../commercialDocuments/components/NoteCommercialDocumentButton";
import { makeStyles } from "@material-ui/core";

interface IUnapprovedInvoiceTable {
  userId?: string;
  isFixedHeight?: boolean;
  userIds?: string[];
}

const useStyles = makeStyles({
  buttonWrap: {
    "& button": {
      marginBottom: 5,
      marginTop: 5,
    },
  },
});

const UnapprovedInvoiceTable = ({
  userId,
  isFixedHeight,
  userIds,
}: IUnapprovedInvoiceTable) => {
  const classes = useStyles();

  const UnapprovedInvoiceFilter = (props: any) => {
    return (
      <Filter {...props}>
        <SearchInput source="search" alwaysOn />
        <SelectInput
          label="Status"
          source="Status"
          choices={statusList}
          alwaysOn
        />
      </Filter>
    );
  };

  return (
    <ResourceContextProvider value="commercialDocuments">
      <List
        basePath="/commercialDocuments"
        actions={null}
        exporter={false}
        hasCreate={false}
        filters={<UnapprovedInvoiceFilter />}
        filterDefaultValues={{
          StatusIn: ["Draft", "Unposted"],
          UserId: userId,
          Type: "Invoice",
          UserIds: userIds,
        }}
        sort={{ field: "id", order: "DESC" }}
        bulkActionButtons={false}
        title=" "
        pagination={
          <Pagination
            limit={isFixedHeight ? <EmptyComponent /> : <PaginationLimit />}
          />
        }
      >
        <Datagrid>
          <TextField source="id" emptyText="-" />
          <TextField
            source="items[0].description"
            label="Description"
            emptyText="-"
          />
          <CustomPriceField source="subTotal" label="Amount" />
          <CustomPriceField source="totalDue" label="Amt. Include VAT" />
          <TextField
            source="accountingCustomerId"
            label="Accounting Customer Id"
            emptyText="-"
          />
          <TextField source="customerName" emptyText="-" />
          <TextField source="note" emptyText="-" />
          <StatusField source="status" />
          <FunctionField
            label="Action"
            render={(record: any) => {
              return (
                <>
                  {localStorage.getItem("roles").includes("superadmin") && (
                    <div className={classes.buttonWrap}>
                      <ApproveCommercialDocumentButton
                        id={record.id}
                        status={record.status}
                        type="invoice"
                      />

                      <NoteCommercialDocumentButton
                          commercialDocumentId={record.id}
                      />

                      {/*{record.status === "draft" && (*/}
                      {/*  <DeleteCommercialDocumentButton*/}
                      {/*    mbcRef={record.id}*/}
                      {/*    type="id"*/}
                      {/*  />*/}
                      {/*)}*/}
                      {/*{record.status === "unposted" && (*/}
                      {/*  <DeleteCommercialDocumentButton*/}
                      {/*    mbcRef={record.mbcRef}*/}
                      {/*    type="mbc"*/}
                      {/*  />*/}
                      {/*)}*/}
                    </div>
                  )}
                </>
              );
            }}
          />
        </Datagrid>
      </List>
    </ResourceContextProvider>
  );
};

export default UnapprovedInvoiceTable;
